import { useState, useEffect, useRef } from 'react';
import WhoAreYouIcon from './WhoAreYouIcon.js';
import CharacterController from '../CharacterChosen/CharacterController.js';
import YouTubeEmbed from '../../../../dmView/components/EncounterColumn/YouTubeEmbed.js';
import io from 'socket.io-client';
import defaultBackground from "../../../../dmView/pics/backgrounds/happyTavern.png"
import { backendUrl } from '../../../../dmView/constants.js';

function WhoAreYou() {

    const playerView = {
        turnNum: 0
    }

    const [playerViewBackground, setPlayerViewBackground] = useState({type: "image", src: defaultBackground});

    const [players, setPlayers] = useState([]);
    const [turnNum, setTurnNum] = useState(playerView.turnNum);
    const [messages, setMessages] = useState([]); // State to store messages
    const [selectedCharacter, setSelectedCharacter] = useState(null);
    const socketRef = useRef(null)
    const [socket, setSocket] = useState(null);
    const [givenName, setGivenName] = useState('');

    const sessiondId = window.location.pathname.split('/')[2]; // Extract the encounter ID from the URL

    const updateCreatureInState = (creatureGuid, updater) => {
        setPlayers((prevPlayers) => {
            return prevPlayers.map((player) => {
                if (player.creatureGuid === creatureGuid) {
                    return updater(player);
                }
                return player;
            });
        });

        setSelectedCharacter((prevSelectedCharacter) => {
            if (prevSelectedCharacter?.creatureGuid === creatureGuid) {
                return updater(prevSelectedCharacter);
            }
            return prevSelectedCharacter;
        });
    };

    useEffect(() => {
        if (!socketRef.current) {
            socketRef.current = io(backendUrl); // Create socket connection
            setSocket(socketRef.current)
        }
    }, [socketRef]);

    useEffect(() => {
        if (!socketRef.current) {
            socketRef.current = io(backendUrl, {
                transports: ["websocket", "polling"],
                reconnectionDelay: 1000,
                reconnection: true,
                reconnectionAttempts: 10,
            });
            setSocket(socketRef.current);
        }

        const socket = socketRef.current;
        if (!socket) return;

        // Emit room ID to the server after connection is established
        socket.on('connect', () => {
            console.log(`Connected to session ${sessiondId}`);
            socket.emit('joinedEncounter', sessiondId); // Send the encounter ID to the server
        });

        // Recieve messages from backend
        socket.on('messageToEncounter', (msg) => {
            setMessages((prevMessages) => [...prevMessages, msg]); 
        });
        
        // Recieve messages from backend
        socket.on('setGivenName', (playerName) => {
            setGivenName(playerName); 
        });

        // Recieve messages from backenddasdasd
        socket.on('populateEncounterPlayers', (resPlayers) => {
            console.log("Players Populated", resPlayers)
            setPlayers([...resPlayers])
        });

        socket.on('playerHpChangeSuccess', (creatureGuid, hpObject) => {
            console.log("playerHpChangeSuccess", creatureGuid, hpObject)
            updateCreatureInState(creatureGuid, (player) => ({ ...player, ...hpObject }));
        });

        socket.on('playerArmorClassSuccess', (creatureGuid, armor_class) => {
            console.log("playerArmorClassSuccess", creatureGuid, armor_class)
            updateCreatureInState(creatureGuid, (player) => ({ ...player, armor_class }));
        });

        socket.on('playerNameSuccess', (creatureGuid, name) => {
            console.log("playerNameSuccess", creatureGuid, name)
            updateCreatureInState(creatureGuid, (player) => ({ ...player, name }));
        });

        socket.on('playerInitSuccess', (creatureGuid, initiative) => {
            console.log("playerInitSuccess", creatureGuid, initiative)
            updateCreatureInState(creatureGuid, (player) => ({ ...player, initiative }));
        });

        socket.on('playerInspirationSuccess', (creatureGuid, inspo) => {
            console.log("playerInspirationSuccess", creatureGuid, inspo)
            updateCreatureInState(creatureGuid, (player) => ({ ...player, inspiration: inspo }));
        });
        
        socket.on('puiChangeSuccess', (key, value, creatureGuid) => {
            console.log("puiChangeSuccess", key, value, creatureGuid)
            updateCreatureInState(creatureGuid, (player) => ({ ...player, [key]: value }));
        });

        socket.on('playerEffectSuccess', (creatureGuid, effect, action) => {
            console.log("playerEffectSuccess", creatureGuid, effect, action)

            const updateEffects = (player) => {
                const nextEffects = [...(player.effects || [])];
                if (action === 'add') {
                    nextEffects.push(effect);
                } else if (action === 'remove') {
                    return {
                        ...player,
                        effects: nextEffects.filter((existingEffect) => existingEffect !== effect),
                    };
                }

                return { ...player, effects: nextEffects };
            };

            updateCreatureInState(creatureGuid, updateEffects);
        });

        // Clean up the socket connection on component unmount
        return () => {
            if(socket) socket.disconnect();
        };
    }, []);


    const handleSetSelectedCharacter = (creature) => {
        setSelectedCharacter(creature)
        socket.emit('characterSelected', creature.creatureGuid, creature.name);
    }

    const handleBackButton = (event) => {
        socket.emit("characterUnselected")
        setSelectedCharacter(null)
    }

    console.log("Players", players)
    console.log("selectedCharacter", selectedCharacter)

    return (
        <div className="playerUiContainer" style={{backgroundImage: playerViewBackground.type === "image" && playerViewBackground.src ? `url(${playerViewBackground.src})` : 'none'}}>  

            {givenName && 
                <div className='joinGivenName'>
                    {givenName}
                </div>
            }

            {playerViewBackground.type === "youtube" && 
                <YouTubeEmbed embedUrl={playerViewBackground.src}/>
            }  


            {selectedCharacter !== null ?
                <CharacterController key={selectedCharacter.creatureGuid} otherPlayers={players} isTurn={turnNum === players.findIndex(player => player.creatureGuid === selectedCharacter.creatureGuid)+1} creature={selectedCharacter} handleBackButton={handleBackButton} socket={socket} />
            :
                <div className="playerJoinDiv">
                    {messages && 
                        <ul className='joinMessageList'>
                            {messages.map((message, index) => (
                                <li className='joinMessageListItem' key={index+message} >
                                    {message}
                                </li>
                            ))}
                        </ul>
                    }
                
                    <div className='whoAreYouContainer'>
                        <div className='joinMessageTitle'>
                            Who are you?
                        </div>  
                        <div className="cardContainerPlayerUi">
                            {!socket ? (
                                <div>Connecting...</div>
                            ) : players.length === 0 ? (
                                    <div className=''>No Player Characters found... Dm needs to add Player Creatures</div>
                            ) : (
                                // Show players and allys in the choose character menu
                                players.map((player, index) => { 
                                    return (player.type === 'player' || player.type === "ally")
                                    ? <WhoAreYouIcon key={player.creatureGuid} creature={player} handleSetSelectedCharacter={handleSetSelectedCharacter} socket={socket}/>
                                    : null;
                                })
                            )}
                        </div>
                    </div>
                </div>
            }
        </div>
        
    );
}


export default WhoAreYou;
